import React from 'react';
import moment from 'moment';
import faker from 'faker';
import { Notes, Restriction, Exception, Check, Circle } from '../Icons';

export const mapCategory = (category) => {
    switch (category) {
        case 'notes': {
            return {
                icon: <Notes size={14} />,
                label: 'Notes',
            };
        }
        case 'restrictions': {
            return {
                icon: <Restriction size={14} />,
                label: 'Restricted Zone',
            };
        }
        case 'exceptions': {
            return {
                icon: <Exception size={14} />,
                label: 'Exceptions',
            };
        }
        case 'workOrdersIssued': {
            return {
                icon: <Circle size={8} />,
                label: 'Work Orders Issued',
            };
        }
        case 'workOrdersCompleted': {
            return {
                icon: <Check size={12} />,
                label: 'Work Orders Completed',
            };
        }
        default: {
            throw new Exception('Not defined category: ' + category);
        }
    }
};

export const sampleData = new Array(21).fill(0).map((r) => ({
    category: faker.random.arrayElement([
        'notes',
        'exceptions',
        'restrictions',
        'workOrdersIssued',
        'workOrdersCompleted',
    ]),
    date: moment(faker.date.between('2017-12-05', '2017-12-12')),
    code: faker.hacker.abbreviation(),
    message: faker.random.arrayElement([null, faker.hacker.phrase()]),
    label: faker.random.arrayElement([null, '000' + faker.finance.amount(100000000, 999999999, 0)]),
}));
